/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CheckDlpGyeonggiAccountIdRequest } from '../models/CheckDlpGyeonggiAccountIdRequest';
import type { CheckDlpGyeonggiAccountVerificationRequest } from '../models/CheckDlpGyeonggiAccountVerificationRequest';
import type { CreateDlpGyeonggiAccountRequest } from '../models/CreateDlpGyeonggiAccountRequest';
import type { CreatePasswordRequest } from '../models/CreatePasswordRequest';
import type { DefaultHttpResponse_AvailableSeoulAccountResponse_ } from '../models/DefaultHttpResponse_AvailableSeoulAccountResponse_';
import type { DefaultHttpResponse_CheckDlpGyeonggiAccountIdResponse_ } from '../models/DefaultHttpResponse_CheckDlpGyeonggiAccountIdResponse_';
import type { DefaultHttpResponse_CheckDlpGyeonggiAccountResponse_ } from '../models/DefaultHttpResponse_CheckDlpGyeonggiAccountResponse_';
import type { DefaultHttpResponse_CheckDlpGyeonggiAccountVerificationResponse_ } from '../models/DefaultHttpResponse_CheckDlpGyeonggiAccountVerificationResponse_';
import type { DefaultHttpResponse_CreateDlpGyeonggiAccountResponse_ } from '../models/DefaultHttpResponse_CreateDlpGyeonggiAccountResponse_';
import type { DefaultHttpResponse_CreateSeoulAccountResponse_ } from '../models/DefaultHttpResponse_CreateSeoulAccountResponse_';
import type { DefaultHttpResponse_CreateSeoulPasswordResponse_ } from '../models/DefaultHttpResponse_CreateSeoulPasswordResponse_';
import type { DefaultHttpResponse_DetailTermsResponse_ } from '../models/DefaultHttpResponse_DetailTermsResponse_';
import type { DefaultHttpResponse_DlpSeoulAppliedPolicyListResponse_ } from '../models/DefaultHttpResponse_DlpSeoulAppliedPolicyListResponse_';
import type { DefaultHttpResponse_DlpSeoulCltrPassApplyResponse_ } from '../models/DefaultHttpResponse_DlpSeoulCltrPassApplyResponse_';
import type { DefaultHttpResponse_DlpSeoulCltrPassCheckResponse_ } from '../models/DefaultHttpResponse_DlpSeoulCltrPassCheckResponse_';
import type { DefaultHttpResponse_DlpSeoulIsltYoungSprtApplyResponse_ } from '../models/DefaultHttpResponse_DlpSeoulIsltYoungSprtApplyResponse_';
import type { DefaultHttpResponse_DlpSeoulIsltYoungSprtCheckResponse_ } from '../models/DefaultHttpResponse_DlpSeoulIsltYoungSprtCheckResponse_';
import type { DefaultHttpResponse_DlpSeoulLoanCrdtRcvrApplyResponse_ } from '../models/DefaultHttpResponse_DlpSeoulLoanCrdtRcvrApplyResponse_';
import type { DefaultHttpResponse_DlpSeoulLoanCrdtRcvrCheckResponse_ } from '../models/DefaultHttpResponse_DlpSeoulLoanCrdtRcvrCheckResponse_';
import type { DefaultHttpResponse_DlpSeoulMemberInfoResponse_ } from '../models/DefaultHttpResponse_DlpSeoulMemberInfoResponse_';
import type { DefaultHttpResponse_LoginDlpGyeonggiAccountResponse_ } from '../models/DefaultHttpResponse_LoginDlpGyeonggiAccountResponse_';
import type { DefaultHttpResponse_LoginSeoulAccountResponse_ } from '../models/DefaultHttpResponse_LoginSeoulAccountResponse_';
import type { DefaultHttpResponse_SeoulIdCheckResponse_ } from '../models/DefaultHttpResponse_SeoulIdCheckResponse_';
import type { DefaultHttpResponse_SeoulVerificationCheckResponse_ } from '../models/DefaultHttpResponse_SeoulVerificationCheckResponse_';
import type { DefaultHttpResponse_SeoulVerificationResponse_ } from '../models/DefaultHttpResponse_SeoulVerificationResponse_';
import type { DefaultHttpResponse_VerifyDlpGyeonggiAccountResponse_ } from '../models/DefaultHttpResponse_VerifyDlpGyeonggiAccountResponse_';
import type { DlpSeoulAppliedPolicyListRequest } from '../models/DlpSeoulAppliedPolicyListRequest';
import type { DlpSeoulCltrPassApplyRequest } from '../models/DlpSeoulCltrPassApplyRequest';
import type { DlpSeoulCltrPassCheckRequest } from '../models/DlpSeoulCltrPassCheckRequest';
import type { DlpSeoulIsltYoungSprtApplyRequest } from '../models/DlpSeoulIsltYoungSprtApplyRequest';
import type { DlpSeoulIsltYoungSprtCheckRequest } from '../models/DlpSeoulIsltYoungSprtCheckRequest';
import type { DlpSeoulLoanCrdtRcvrApplyRequest } from '../models/DlpSeoulLoanCrdtRcvrApplyRequest';
import type { DlpSeoulLoanCrdtRcvrCheckRequest } from '../models/DlpSeoulLoanCrdtRcvrCheckRequest';
import type { IdCheckRequest } from '../models/IdCheckRequest';
import type { JoinRequest } from '../models/JoinRequest';
import type { JoinVerificationCheckRequest } from '../models/JoinVerificationCheckRequest';
import type { JoinVerificationRequest } from '../models/JoinVerificationRequest';
import type { LoginDlpGyeonggiAccountRequest } from '../models/LoginDlpGyeonggiAccountRequest';
import type { LoginRequest } from '../models/LoginRequest';
import type { VerifyDlpGyeonggiAccountRequest } from '../models/VerifyDlpGyeonggiAccountRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DlpApiService {
    /**
     * 계정정보 확인 및 로그인
     * 계정정보가 있는지 확인 후 로그인을 시도합니다.
     * @returns DefaultHttpResponse_CheckDlpGyeonggiAccountResponse_ OK
     * @throws ApiError
     */
    public static checkDlpGyeonggiAccountUsingGet(): CancelablePromise<DefaultHttpResponse_CheckDlpGyeonggiAccountResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/wello/v2/auth/dlp/gyeonggi/account',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * 가입 과정 Step 2 - 아이디 중복 확인
     * 아이디가 사용 가능한 지 확인합니다.
     * @returns DefaultHttpResponse_CheckDlpGyeonggiAccountIdResponse_ OK
     * @throws ApiError
     */
    public static checkDlpGyeonggiAccountIdUsingPost({
        requestBody,
    }: {
        requestBody?: CheckDlpGyeonggiAccountIdRequest,
    }): CancelablePromise<DefaultHttpResponse_CheckDlpGyeonggiAccountIdResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/gyeonggi/account/id/check',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * 가입 과정 Step 3 - 회원 가입 진행
     * 주어진 정보로 회원가입을 진행합니다.
     * @returns DefaultHttpResponse_CreateDlpGyeonggiAccountResponse_ OK
     * @throws ApiError
     */
    public static saveDlpGyeonggiAccountUsingPost({
        requestBody,
    }: {
        requestBody?: CreateDlpGyeonggiAccountRequest,
    }): CancelablePromise<DefaultHttpResponse_CreateDlpGyeonggiAccountResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/gyeonggi/account/join',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * 로그인
     * ID, PW 으로 로그인 합니다.
     * @returns DefaultHttpResponse_LoginDlpGyeonggiAccountResponse_ OK
     * @throws ApiError
     */
    public static loginDlpGyeonggiAccountUsingPost({
        requestBody,
    }: {
        requestBody?: LoginDlpGyeonggiAccountRequest,
    }): CancelablePromise<DefaultHttpResponse_LoginDlpGyeonggiAccountResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/gyeonggi/account/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * 가입 과정 Step 1.1 - 본인인증
     * 휴대폰 본인인증을 합니다. 사용자 ID 을 찾는데도 사용할 수 있습니다.
     * @returns DefaultHttpResponse_VerifyDlpGyeonggiAccountResponse_ OK
     * @throws ApiError
     */
    public static verifyDlpGyeonggiAccountIdentificationUsingPost({
        requestBody,
    }: {
        requestBody?: VerifyDlpGyeonggiAccountRequest,
    }): CancelablePromise<DefaultHttpResponse_VerifyDlpGyeonggiAccountResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/gyeonggi/account/verification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * 가입 과정 Step 1.2 - 본인인증 확인 및 가입 여부 확인
     * SMS 인증 코드 값을 입력해 가입 여부를 확인하고 다음 단계를 진행할 준비를 합니다.
     * @returns DefaultHttpResponse_CheckDlpGyeonggiAccountVerificationResponse_ OK
     * @throws ApiError
     */
    public static checkDlpGyeonggiAccountIdentificationUsingPost({
        requestBody,
    }: {
        requestBody?: CheckDlpGyeonggiAccountVerificationRequest,
    }): CancelablePromise<DefaultHttpResponse_CheckDlpGyeonggiAccountVerificationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/gyeonggi/account/verification/check',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 계정 확인 및 로그인
     * 서울특별시 계정 저장 여부를 반환하고 로그인을 시도합니다.
     * @returns DefaultHttpResponse_AvailableSeoulAccountResponse_ OK
     * @throws ApiError
     */
    public static getDlpSeoulAccountAndRequestLoginUsingPost(): CancelablePromise<DefaultHttpResponse_AvailableSeoulAccountResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/account',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 아이디 중복 확인 요청
     * 서울특별시 아이디 중복 확인을 시도합니다.
     * @returns DefaultHttpResponse_SeoulIdCheckResponse_ OK
     * @throws ApiError
     */
    public static requestDlpSeoulIdCheckUsingPost({
        requestBody,
    }: {
        requestBody?: IdCheckRequest,
    }): CancelablePromise<DefaultHttpResponse_SeoulIdCheckResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/account/id/check',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 회원가입 요청
     * 서울특별시 회원가입을 시도합니다.
     * @returns DefaultHttpResponse_CreateSeoulAccountResponse_ OK
     * @throws ApiError
     */
    public static createAccountUsingPost({
        requestBody,
    }: {
        requestBody?: JoinRequest,
    }): CancelablePromise<DefaultHttpResponse_CreateSeoulAccountResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/account/join',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 로그인 요청
     * 서울특별시 로그인 요청을 시도합니다.
     * @returns DefaultHttpResponse_LoginSeoulAccountResponse_ OK
     * @throws ApiError
     */
    public static requestLoginUsingPost({
        requestBody,
    }: {
        requestBody?: LoginRequest,
    }): CancelablePromise<DefaultHttpResponse_LoginSeoulAccountResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/account/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 관련 회원 정보 조회
     * @returns DefaultHttpResponse_DlpSeoulMemberInfoResponse_ OK
     * @throws ApiError
     */
    public static getDlpSeoulMemberInfoUsingPost(): CancelablePromise<DefaultHttpResponse_DlpSeoulMemberInfoResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/account/member-info',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 비밀번호 변경 요청
     * 서울특별시 비밀번호 변경을 시도합니다.
     * @returns DefaultHttpResponse_CreateSeoulPasswordResponse_ OK
     * @throws ApiError
     */
    public static changeMemberPasswordUsingPut({
        requestBody,
    }: {
        requestBody?: CreatePasswordRequest,
    }): CancelablePromise<DefaultHttpResponse_CreateSeoulPasswordResponse_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/wello/v2/auth/dlp/seoul/account/password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 비밀번호 변경 본인인증 요청
     * 서울특별시 비밀번호 변경 본인인증을 시도합니다.
     * @returns DefaultHttpResponse_SeoulVerificationResponse_ OK
     * @throws ApiError
     */
    public static requestDlpSeoulVerificationForPasswordUsingPost({
        requestBody,
    }: {
        requestBody?: JoinVerificationRequest,
    }): CancelablePromise<DefaultHttpResponse_SeoulVerificationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/account/password-verification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 비밀번호 변경 본인인증 확인 요청
     * 서울특별시 비밀번호 변경 본인인증 확인을 시도합니다.
     * @returns DefaultHttpResponse_SeoulVerificationCheckResponse_ OK
     * @throws ApiError
     */
    public static requestDlpSeoulVerificationCheckForPasswordUsingPost({
        requestBody,
    }: {
        requestBody?: JoinVerificationCheckRequest,
    }): CancelablePromise<DefaultHttpResponse_SeoulVerificationCheckResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/account/password-verification/check',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 개인정보 수집이용내역 요청
     * 서울특별시 개인정보 수집이용내역을 요청합니다..
     * @returns DefaultHttpResponse_DetailTermsResponse_ OK
     * @throws ApiError
     */
    public static getDetailTermsOfPrivacyUsingGet(): CancelablePromise<DefaultHttpResponse_DetailTermsResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/wello/v2/auth/dlp/seoul/account/privacy-policy-first',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 이용약관 요청
     * 서울특별시 이용약관 정보를 요청합니다..
     * @returns DefaultHttpResponse_DetailTermsResponse_ OK
     * @throws ApiError
     */
    public static getDetailTermsOfServiceUsingGet(): CancelablePromise<DefaultHttpResponse_DetailTermsResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/wello/v2/auth/dlp/seoul/account/terms-of-service',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 본인인증 요청
     * 서울특별시 본인인증을 시도합니다.
     * @returns DefaultHttpResponse_SeoulVerificationResponse_ OK
     * @throws ApiError
     */
    public static requestDlpSeoulVerificationUsingPost({
        requestBody,
    }: {
        requestBody?: JoinVerificationRequest,
    }): CancelablePromise<DefaultHttpResponse_SeoulVerificationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/account/verification',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 본인인증 확인 요청
     * 서울특별시 본인인증 확인을 시도합니다.
     * @returns DefaultHttpResponse_SeoulVerificationCheckResponse_ OK
     * @throws ApiError
     */
    public static requestDlpSeoulVerificationCheckUsingPost({
        requestBody,
    }: {
        requestBody?: JoinVerificationCheckRequest,
    }): CancelablePromise<DefaultHttpResponse_SeoulVerificationCheckResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/account/verification/check',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 신청한 정책 보기
     * @returns DefaultHttpResponse_DlpSeoulAppliedPolicyListResponse_ OK
     * @throws ApiError
     */
    public static getDlpSeoulAppliedPolicyListUsingPost({
        requestBody,
    }: {
        requestBody?: DlpSeoulAppliedPolicyListRequest,
    }): CancelablePromise<DefaultHttpResponse_DlpSeoulAppliedPolicyListResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/applied-policy-list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 청년문화 패스 신청
     * @returns DefaultHttpResponse_DlpSeoulCltrPassApplyResponse_ OK
     * @throws ApiError
     */
    public static getDlpSeoulCulturePassApplyUsingPost({
        requestBody,
    }: {
        requestBody?: DlpSeoulCltrPassApplyRequest,
    }): CancelablePromise<DefaultHttpResponse_DlpSeoulCltrPassApplyResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/cltr-pass/apply',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 청년문화 패스 주민번호 사전 확인 요청
     * @returns DefaultHttpResponse_DlpSeoulCltrPassCheckResponse_ OK
     * @throws ApiError
     */
    public static getDlpSeoulCltrPassCheckUsingPost({
        requestBody,
    }: {
        requestBody?: DlpSeoulCltrPassCheckRequest,
    }): CancelablePromise<DefaultHttpResponse_DlpSeoulCltrPassCheckResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/cltr-pass/check',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 고립•은둔청년 지원사업 신청
     * @returns DefaultHttpResponse_DlpSeoulIsltYoungSprtApplyResponse_ OK
     * @throws ApiError
     */
    public static getDlpSeoulIsltYoungSprtApplyUsingPost({
        requestBody,
    }: {
        requestBody?: DlpSeoulIsltYoungSprtApplyRequest,
    }): CancelablePromise<DefaultHttpResponse_DlpSeoulIsltYoungSprtApplyResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/islt-youth-sprt/apply',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 고립•은둔청년 지원사업 주민번호 사전 확인 요청
     * @returns DefaultHttpResponse_DlpSeoulIsltYoungSprtCheckResponse_ OK
     * @throws ApiError
     */
    public static getDlpSeoulIsltYoungSprtCheckUsingPost({
        requestBody,
    }: {
        requestBody?: DlpSeoulIsltYoungSprtCheckRequest,
    }): CancelablePromise<DefaultHttpResponse_DlpSeoulIsltYoungSprtCheckResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/islt-youth-sprt/check',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 학자금대출 신용회복 신청
     * @returns DefaultHttpResponse_DlpSeoulLoanCrdtRcvrApplyResponse_ OK
     * @throws ApiError
     */
    public static getDlpSeoulLoanCrdtRcvrApplyUsingPost({
        requestBody,
    }: {
        requestBody?: DlpSeoulLoanCrdtRcvrApplyRequest,
    }): CancelablePromise<DefaultHttpResponse_DlpSeoulLoanCrdtRcvrApplyResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/loan-crdt-rcvr/apply',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
    /**
     * DLP 서울특별시 학자금대출 신용회복 주민번호 사전 확인 요청
     * @returns DefaultHttpResponse_DlpSeoulLoanCrdtRcvrCheckResponse_ OK
     * @throws ApiError
     */
    public static getDlpSeoulLoanCrdtRcvrCheckUsingPost({
        requestBody,
    }: {
        requestBody?: DlpSeoulLoanCrdtRcvrCheckRequest,
    }): CancelablePromise<DefaultHttpResponse_DlpSeoulLoanCrdtRcvrCheckResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/wello/v2/auth/dlp/seoul/loan-crdt-rcvr/check',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `SQL 오류 및 기타 미처리 예외 상황입니다.`,
                502: `외부 API 오류 입니다.`,
            },
        });
    }
}
